export type CoverType = {
    Image: "image",
    Video: "video"
}

export const expURL =
    /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;

export const maxCoverSize: number = 4;

export const coversGrid = [
    {
        size: 1,
        columns: 1,
        grid: [
            {
                width: "100%",
                height: "auto",
                style: { borderRadius: "8px", position: "relative", maxHeight: "calc(688px - 3rem)"}
            }
        ]
    },
    {
        size: 2,
        columns: 2,
        grid: [
            {
                width: 1,
                height: 1,
                style: {
                    borderRadius: "8px 0px 0px 8px",
                    // objectPosition: "50% 100%",
                }
            },
            {
                width: 1,
                height: 1,
                style: {
                    borderRadius: "0px 8px 8px 0px",
                    // objectPosition: "50% 100%",
                }
            }
        ]
    },
    {
        size: 3,
        columns: 2,
        grid: [
            {
                width: 160,
                height: 162,
                style: { borderRadius: "8px 0px 0px 8px"}
            },
            {
                width: 2,
                height: 1,
                style: { borderRadius: "0px 8px 0px 0px"}
            },
            {
                width: 2,
                height: 1,
                style: { borderRadius: "0px 0px 8px 0px"}
            }
        ]
    },
    {
        size: 4,
        columns: 2,
        grid: [
            {
                width: 2,
                height: 1,
                style: { borderRadius: "8px 0px 0px 0px"}
            },
            {
                width: 2,
                height: 1,
                style: { borderRadius: "0px 8px 0px 0px"}
            },
            {
                width: 2,
                height: 1,
                style: { borderRadius: "0px 0px 0px 8px"}
            },
            {
                width: 2,
                height: 1,
                style: { borderRadius: "0px 0px 8px 0px"}
            }
        ]
    }
]

export const photos = [
    {
        src: "https://source.unsplash.com/2ShvY8Lf6l0/800x599",
        width: 4,
        height: 4
    },
    // {
    //     src: "https://source.unsplash.com/Dm-qxdynoEc/800x799",
    //     width: 1,
    //     height: 1
    // },
    // {
    //     src: "https://source.unsplash.com/qDkso9nvCg0/600x799",
    //     width: 3,
    //     height: 4
    // },
    // {
    //     src: "https://source.unsplash.com/iecJiKe_RNg/600x799",
    //     width: 3,
    //     height: 4
    // },
    // {
    //     src: "https://source.unsplash.com/epcsn8Ed8kY/600x799",
    //     width: 3,
    //     height: 4
    // },
    // {
    //     src: "https://source.unsplash.com/NQSWvyVRIJk/800x599",
    //     width: 4,
    //     height: 3
    // },
    // {
    //     src: "https://source.unsplash.com/zh7GEuORbUw/600x799",
    //     width: 3,
    //     height: 4
    // },
    // {
    //     src: "https://source.unsplash.com/PpOHJezOalU/800x599",
    //     width: 4,
    //     height: 3
    // },
    // {
    //     src: "https://source.unsplash.com/I1ASdgphUH4/800x599",
    //     width: 4,
    //     height: 3
    // }
];

export const allPrivacyOption = [
    {
        value: "friends",
        label: "Only friends",
    },
    {
        value: "public",
        label: "Public",
    },
    {
        value: "tag",
        label: "Only with tag",
    },
    {
        value: "draft",
        label: "Save Draft",
    },
];
